import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ResourceAppResource from "./ResourceAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import ServiceProviderUserProfessionalAppResource from "./ServiceProviderUserProfessionalAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";

export const RESOURCE_7_SOURCE = 'resource-7-source';
export const REFINANCE_YOUR_HOME_SOURCE = 'refinance-your-home-source';
export const INSURANCE_CARD_SOURCE = 'insurance-card-source';

class ServiceProviderMessageAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-message';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/messages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'from',
            'email',
            'phone',
            'respondByEmail',
            'respondByPhone',
            'respondByText',
            'message',
            'serviceProviderUuid',
            'organizationMemberUuid',
            'workspaceUuid',
            'resourceUuid',
            'serviceProviderContactUuid',
            'serviceProviderUserProfessionalUuid',
            'serviceProviderTypeUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            serviceProvider: ServiceProviderAppResource,
            organizationMember: OrganizationMemberAppResource,
            workspace: WorkspaceAppResource,
            resource: ResourceAppResource,
            serviceProviderContact: ServiceProviderContactAppResource,
            serviceProviderUserProfessional: ServiceProviderUserProfessionalAppResource,
            serviceProviderType: ServiceProviderTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            serviceProvider: 'service_provider_uuid',
            organizationMember: 'organization_member_uuid',
            workspace: 'workspace_uuid',
            resource: 'resource_uuid',
            serviceProviderContact: 'service_provider_contact_uuid',
            serviceProviderUserProfessional: 'service_provider_user_professional_uuid',
            serviceProviderType: 'service_provider_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            from: {
                type: 'string',
                presence: true,
            },
            email: {
                type: 'string',
            },
            phone: {
                type: 'string',
            },
            respondByEmail: {
                type: 'boolean',
            },
            respondByPhone: {
                type: 'boolean',
            },
            respondByText: {
                type: 'boolean',
            },
            message: {
                type: 'string',
                presence: true,
            },
            serviceProviderUuid: {
                type: 'string',
            },
            serviceProviderContactUuid: {
                type: 'string',
            },
            serviceProviderUserProfessionalUuid: {
                type: 'string',
            },
            organizationMemberUuid: {
                type: 'string',
            },
            workspaceUuid: {
                type: 'string',
            },
            resourceUuid: {
                type: 'string',
            },
            serviceProviderTypeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }
}

export default ServiceProviderMessageAppResource;
